import React from "react";
import Lottie from "react-lottie";
import animationData from "../../Assets/lottie/new-animation.json";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function isRTL() {
  if (typeof document !== "undefined") {
    const dir =
      document.body?.dir ||
      document.documentElement?.dir ||
      document.documentElement?.getAttribute("dir");
    return dir === "rtl";
  }
  return false;
}

const ExploreCard = ({ category }) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const { t } = useTranslation("result");
  const rtl = isRTL();

  return (
    <div className="relative md-max:h-[16rem] md-max:mt-10 md-max:overflow-hidden">
      <img
        src={"/new-explore-card-bg.png"}
        alt="bg-img"
        className="w-full object-cover h-[15rem] md-max:h-[16rem] rounded-2xl"
      />
      <div className="md-max:absolute top-0 left-0 flex items-center w-full justify-between">
        <div className={`absolute md-max:relative top-1/2 -translate-y-1/2 ${rtl ? 'right-10 md-max:right-5' : 'left-10 md-max:left-5'} md-max:top-5 md-max:translate-y-0 flex flex-col gap-4`}>
          <p className="text-3xl md-max:text-lg font-bold text-white">
            {t("exploreCard.text1")} <br className="md:hidden" /> {t("exploreCard.text2")}{" "}
            <br className="md:hidden" /> {t("exploreCard.text3")}
          </p>
          <p className="text-lg md-max:text-sm text-white">
            {t("exploreCard.text4")} <br className="md:hidden" />
            <span className="text-[#2EDAF7] font-semibold">
              {/* {tabIndex === 1
                ? "strength and weakness"
                : tabIndex === 2
                ? "career-path"
                : tabIndex === 3
                ? "workplace habit"
                : "strength and weakness"} */}
                {category !== "Introduction" || category !== "Conclusion" ? category : "Strength & Challenges"}
            </span>
          </p>
          <Link to={"/ai-agent"}>
            <button className="rounded-full border border-white cursor-pointer bg-white/20 px-6 py-3 md-max:text-xs md-max:px-4 md-max:py-2 text-white font-semibold w-max">
              {t("exploreCard.button")}
            </button>
          </Link>
        </div>
        <div className={`absolute md-max:relative -top-20 md-max:top-auto md-max:bottom-0 md-max:scale-[1.5] ${rtl ? 'left-0 lg:xl-max:left-[5%]' : 'right-0 lg:xl-max:right-[5%]'} scale-[1.5]`}>
          <Lottie options={defaultOptions} height={150} width={150} />
        </div>
      </div>
    </div>
  );
};

export default ExploreCard;
